import React from 'react'

import { Filter } from './Filter'
import MapProperties from './Map/Map'
import { AUX } from '../../../hoc/'


export const Detail = props => {
    const { accommodates, bedrooms, occupacity, onChange, onChangeAccommodates, onChangeBedrooms, onChangeOccupacity, onSubmit, properties } = props
    return (
        <AUX>
            <Filter
                accommodates={accommodates}
                bedrooms={bedrooms}
                occupacity={occupacity}
                onChange={onChange}
                onChangeAccommodates={onChangeAccommodates}
                onChangeBedrooms={onChangeBedrooms}
                onChangeOccupacity={onChangeOccupacity}
                onSubmit={onSubmit}
            />
            <hr />
            <MapProperties properties={properties} />
        </AUX>
    )
}